import { Navigate, useLocation } from "react-router-dom";
import MAP from "../data/legacy_redirects.json";
import NotFound from "../pages/NotFound";

export function resolveLegacyPath(pathname) {
  const path = decodeURIComponent(pathname).toLowerCase().replace(/\/+$/, "") || "/";
  if (MAP.exact[path]) return MAP.exact[path];
  const prefix = Object.keys(MAP.prefix).find((p) => path.startsWith(p));
  return prefix ? MAP.prefix[prefix] : null;
}

export const LegacyRedirect = () => {
  const { pathname, search } = useLocation();
  const target = resolveLegacyPath(pathname);
  if (!target) return <NotFound />;
  return <Navigate to={`${target}${search || ""}`} replace />;
};
